/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://fjzke4x4jfaybksrgrm3epz6m4.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-yh2k2alfifb4zjouwqohfj6duy",
    "aws_cognito_identity_pool_id": "us-east-2:569a81e7-6586-43aa-b7e2-5465f18049a8",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_7xNs74QXK",
    "aws_user_pools_web_client_id": "6ch3jg8g8t64u8o0l27jpe93am",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "gallerybucket163335-staging",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
